import { z } from 'zod'

export const loginDecryptFfpMemberSchema = z.object({
  memberCardNumber: z.string()
})

export interface LoginDecryptFfpMember
  extends z.infer<typeof loginDecryptFfpMemberSchema> {}
